import { decisionsGet, get } from "_shared/request";
import { getEnv } from "../../../../utils/constants";
import { user } from "_shared/auth";

export const getApprovals = () => {
  return decisionsGet({
    url: `${getEnv("DECISIONS_ENDPOINT")}/Primary/`,
    params: {
      FlowAlias: "PendingApprovalsGAR",
      Action: "api",
      outputtype: "JSON",
      RequesterTeamID: user.TeamId,
    },
  });
};

export const getGdrUploadUrls = async (fileNames) => {
  try {
    const { data } = await get({
      url: `${getEnv("BASEURL")}/gdrblobstorage/generate-upload-file-url`,
      params: { filenames: fileNames },
      paramsSerializer: { indexes: null },
    });
    return data;
  } catch (error) {
    const status = error?.httpResponse?.status;
    if (status === 401 || status === 403) {
      const authError = new Error("User is not allowed to upload GDR documents");
      authError.code = "GDR_UPLOAD_FORBIDDEN";
      throw authError;
    }
    throw error;
  }
};